// extracted by mini-css-extract-plugin
module.exports = {"auth__container":"Screen_auth__container__1PtjA","left":"Screen_left__3ZL7R","right":"Screen_right__YBGTD","back":"Screen_back__3nnbP"};